import type { AdConfig, AdnKeyValue } from '../api/index.js';

// atm config server is sending kv's as an object, we need them as an array
export const transformAdnKeyValuesToArray = (adConfig: AdConfig) => {
  const adnKv = adConfig.adServer.adn?.kv ?? {};

  return Object.entries(adnKv).map<AdnKeyValue>(([key, values]) => ({
    [key]: values.flat()
  }));
};
